/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const PresentationVerify: core.serialization.ObjectSchema<
    serializers.PresentationVerify.Raw,
    Truvity.PresentationVerify
> = core.serialization.object({
    verified: core.serialization.boolean(),
});

export declare namespace PresentationVerify {
    export interface Raw {
        verified: boolean;
    }
}
